import { ICompany } from 'src/interfaces';
import { CompaniesActionType } from '../action-types';
import { CompaniesAction } from '../actions';

interface CompaniesState {
  loading: boolean;
  error: string | null;
  data: { companies: ICompany[] };
}

const initialState = {
  loading: false,
  error: null,
  data: { companies: [] },
};

const reducer = (state: CompaniesState = initialState, action: CompaniesAction): CompaniesState => {
  switch (action.type) {
    case CompaniesActionType.GET_COMPANIES:
      return { loading: true, error: null, data: { companies: [] } };
    case CompaniesActionType.GET_COMPANIES_SUCCESS:
      return { loading: false, error: null, data: action.payload };
    case CompaniesActionType.GET_COMPANIES_FAILURE:
      return { loading: false, error: action.payload, data: { companies: [] } };
    default:
      return state;
  }
};

export default reducer;
